
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const CustRefPayInvoice = () => {
    const { id } = useParams<{ id: string }>();
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchInvoice = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_WALLET_PERFIX}/payouts/invoice/${id}`,
                    { withCredentials: true }
                );
                setData(response.data);
            } catch (err: any) {
                setError(err.response?.data?.message || "Failed to fetch invoice details");
            } finally {
                setLoading(false);
            }
        };
        if (id) {
            fetchInvoice();
        }
    }, [id]);

    const handlePrint = () => {
        window.print();
    };

    if (loading) {
        return (
            <div className="text-center p-5">
                <div className="spinner-border text-dark" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error || !data) {
        return (
            <div className="text-center p-5 text-danger">
                {error || "Invoice details not available"}
            </div>
        );
    }

    return (
        <>
            <style>{`
                @media print {
                    .no-print {
                        display: none !important;
                    }
                    body {
                        background: white;
                        color: black;
                    }
                }
            `}</style>
            <div className="container mt-3 no-print">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <Link to="/WithdrawlHistory" className="btn btn-outline-dark">
                        <i className="ri-arrow-left-line"></i> Back to List
                    </Link>
                    <button onClick={handlePrint} className="btn btn-dark">
                        <i className="ri-printer-line"></i> Print Invoice
                    </button>
                </div>
            </div>
            <div className=' display-max'>
                <section className="invoice-page">
                    <header className="top">
                        <div className="invoice-title">
                            <div>
                                <img src="../../assets/img/salarlogo.png" className='invoice-logo' alt="" />
                            </div>
                            <strong className=' text-black'>{data.invoiceTitle || "Customer Referral Incentive Payouts"}</strong>
                            <span className=' text-sm text-black'>(Original for Recipient)</span>
                        </div>
                    </header>
                    <div className="order-grid">
                        <div className=' text-black'>
                            <div className=' text-black'><b>Date :</b>{data.date}</div>
                            <div className=' text-black'><b>Payout Date :</b>{data.payoutDate}</div>
                        </div>
                        <div className="right">
                            <div className=' text-black'><b>Payout Referral ID :</b>#{data.payoutReferralId}</div>
                            <div className=' text-black'><b>Transaction ID :</b>{data.transactionId}</div>
                        </div>
                    </div>
                    <div className="address-grid-2">
                        <div className="seller">
                            <div className="seller-meta">
                                <h3 className=' text-black'>Customer Details :</h3>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1">
                                    <div className=' text-black col-3'><b>Referral ID:</b></div>
                                    <div className=' text-black col-9'>{data.customerDetails?.referralId}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Name:</b></div>
                                    <div className=' text-black col-9'>{data.customerDetails?.name}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>S/o:</b></div>
                                    <div className=' text-black col-9'>{data.customerDetails?.fatherName}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Age:</b></div>
                                    <div className=' text-black col-9'>{data.customerDetails?.age}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>DOB:</b></div>
                                    <div className=' text-black col-9'>{data.customerDetails?.dob}</div>
                                </div>
                            </div>
                            <div className="seller-meta mt-2">
                                <h3 className=' text-black'>Kyc Details : <b className=" text-success">{data.kycDetails?.kycStatus}</b></h3>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1">
                                    <div className=' text-black col-3'><b>Aadhaar No:</b></div>
                                    <div className=' text-black col-9'>{data.kycDetails?.aadhaarNo}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Pan No:</b></div>
                                    <div className=' text-black col-9'>{data.kycDetails?.panNo}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Voter ID:</b></div>
                                    <div className=' text-black col-9'>{data.kycDetails?.voterId}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Passport:</b></div>
                                    <div className=' text-black col-9'>{data.kycDetails?.passport}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mb-1">
                                    <div className=' text-black col-3'><b>Driving License:</b></div>
                                    <div className=' text-black col-9'>{data.kycDetails?.drivingLicense}</div>
                                </div>
                            </div>
                        </div>
                        <div className="addresses right">
                            <div className="address-block">
                                <h3 className=' text-black'>Bank Details :</h3>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Country:</b></div>
                                    <div className=' text-black col-3'>{data.bankDetails?.country}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Bank Name:</b></div>
                                    <div className=' text-black col-3'>{data.bankDetails?.bankName}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Account No:</b></div>
                                    <div className=' text-black col-3'>{data.bankDetails?.accountNumber}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Account Type:</b></div>
                                    <div className=' text-black col-3'>{data.bankDetails?.accountType}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>IFSC Code:</b></div>
                                    <div className=' text-black col-3'>{data.bankDetails?.ifscCode}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Branch Name:</b></div>
                                    <div className=' text-black col-3'>{data.bankDetails?.branchName}</div>
                                </div>
                                <div className="d-flex justify-content-start gap-3 mt-1 mb-1 px-3">
                                    <div className=' text-black col-9'><b>Pan Card:</b></div>
                                    <div className=' text-black col-3'>{data.bankDetails?.panCard}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table className="items-2 product-table">
                        <thead className=' text-black'>
                            <tr>
                                <th className=' text-black'>Sl.<br />No</th>
                                <th className="desc text-black">Description</th>
                                <th className=' text-black'>Net<br />Amount</th>
                                <th className=' text-black'>Payout<br />Charge</th>
                                <th className=' text-black'>GST</th>
                                <th className=' text-black'>Tax<br />Amount</th>
                                <th className=' text-black'>Total<br />Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="product-row">
                                <td className="center text-black">1</td>
                                <td className=' text-black'>{data.financialDetails?.description}</td>
                                <td className=' text-black'>₹{Number(data.financialDetails?.netAmount || 0).toFixed(2)}</td>
                                <td className=' text-black'>₹{Number(data.financialDetails?.payoutCharge || 0).toFixed(2)}</td>
                                <td className=' text-black'>{data.financialDetails?.gstRate}%</td>
                                <td className=' text-black'>₹{Number(data.financialDetails?.taxAmount || 0).toFixed(2)}</td>
                                <td className=' text-black'>₹{Number(data.financialDetails?.totalAmount || 0).toFixed(2)}</td>
                            </tr>
                            <tr className="total-row">
                                <td colSpan={5} className=' text-black'><b>TOTAL:</b></td>
                                <td className=' text-black'><b>₹{Number(data.financialDetails?.taxAmount || 0).toFixed(2)}</b></td>
                                <td className=' text-black'><b>₹{Number(data.financialDetails?.totalAmount || 0).toFixed(2)}</b></td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="words">
                        <b className=' text-black'>Amount in Words:</b><br />
                        <strong className=' text-black text-capitalize'>{data.financialDetails?.amountInWords}</strong>
                    </div>
                    <div className="sign-box">
                        <div className="sign-content text-black">
                            <b>For {data.companyName || "SWORLD SOLUTIONS PVT LTD"}:</b>
                            <div className="signature scribble">{data.authorizedSignatory || "D. Suraj Ahmed"}</div>
                            <strong>Authorized Signatory</strong>
                        </div>
                    </div>
                    <div className="reverse text-black">Sworld Solutions Private Limited</div>
                    <div className="reverse text-black">contact@salar.in</div>
                </section>
            </div>
        </>
    );
};

export default CustRefPayInvoice;